import React, { useEffect, useRef, useState } from 'react'
import DateFnsUtils from '@date-io/date-fns'
import { useSelector } from 'react-redux'
import { debounce } from 'ts-debounce'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date'

import { dateHelpers } from '@/helper'
import { datatableSelectors } from './store'

const DEBOUNCE_DELAY = 600

type Props = {
	onChange: (value: any) => void
	dataKey: string
}

const DatatableDatepickerFilter = ({ dataKey, onChange }: Props) => {
	const [value, setValue] = useState('')
	const debounceChangeDate = useRef(
		debounce((v) => {
			onChange(v)
		}, DEBOUNCE_DELAY),
	).current
	const filter = useSelector(datatableSelectors.getFilter(dataKey))

	useEffect(() => {
		setValue((filter.value as string) || '')
	}, [filter.value])

	const handleChangeDate = (date: MaterialUiPickersDate | null, v?: string | null) => {
		if (!date || !v) {
			setValue('')
			debounceChangeDate('')
			return
		}
		const isValid = dateHelpers.isDateValid(date)
		if (isValid) {
			debounceChangeDate(v)
		}
		setValue(v)
	}

	const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = e.target
		const valueWithoutNumbers = value.replaceAll('_', '')
		const clearedValue = valueWithoutNumbers.replaceAll('-', '')
		if (clearedValue.length === 0) {
			debounceChangeDate('')
			setValue('')
		}
	}

	return (
		<MuiPickersUtilsProvider utils={DateFnsUtils}>
			<KeyboardDatePicker
				clearable
				value={value.length ? new Date(value) : null}
				onChange={handleChangeDate}
				onInput={handleInput}
				minDate={new Date('2000-01-01')}
				format="yyyy-MM-dd"
				fullWidth={true}
			/>
		</MuiPickersUtilsProvider>
	)
}

export default DatatableDatepickerFilter
